import { render, staticRenderFns } from "./DiagManagementDetail.vue?vue&type=template&id=354af24d&scoped=true&"
import script from "./DiagManagementDetail.vue?vue&type=script&lang=js&"
export * from "./DiagManagementDetail.vue?vue&type=script&lang=js&"
import style0 from "./DiagManagementDetail.vue?vue&type=style&index=0&id=354af24d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354af24d",
  null
  
)

export default component.exports